import { Box, Flex } from '@/components/atoms/Grid'
import { H2, Small } from '@/components/atoms/typography'
import useTranslation from 'next-translate/useTranslation'
import { FC } from 'react'
import { Rating } from 'react-simple-star-rating'
import styled, { useTheme } from 'styled-components'

type OverallRatingProps = {
  rateCounts: number
  rateTotal: number
}

const StarRatingOverall: FC<OverallRatingProps> = ({
  rateCounts,
  rateTotal
}) => {
  const theme = useTheme()
  const { t } = useTranslation('common')
  return (
    <StyledFlex>
      <H2 mb="12px" mt={0}>
        {rateTotal?.toFixed(1)}
      </H2>
      <Box mb="6px">
        <Rating
          readonly
          initialValue={rateTotal}
          allowFraction={true}
          size={16}
          fillColor={theme.colors.sizeTableDescription}
        />
      </Box>
      <Small m={0} opacity={0.6}>
        {rateCounts} {t('ProductDetail.Reviews.inflectedReviews')}
      </Small>
    </StyledFlex>
  )
}

export default StarRatingOverall

const StyledFlex = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`
